"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _UiContext = _interopRequireDefault(require("../../context/UiContext"));
var _cookie = require("../../utils/cookie");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react-hooks/exhaustive-deps */

const Ui = props => {
  const {
    settings
  } = props;
  const {
    uiSettings
  } = settings || {};
  const [ui, setUi] = (0, _react.useState)({});
  const {
    _searchData
  } = ui;
  (0, _react.useEffect)(() => {
    setUi(prevUi => ({
      ...prevUi,
      _settings: uiSettings
    }));
  }, [uiSettings]);
  (0, _react.useEffect)(() => {
    if ((0, _isEmpty.default)(_searchData)) return;

    // save searchData to cookie (session)

    (0, _cookie.setCookie)("mco-ui-searchData", JSON.stringify(_searchData));
  }, [JSON.stringify(_searchData)]);
  (0, _react.useEffect)(() => {
    // read searchData from cookie

    const cookie = (0, _cookie.getCookie)("mco-ui-searchData");
    if (cookie !== "") {
      try {
        var _searchData$range, _searchData$range3;
        const searchData = JSON.parse(cookie);
        if (searchData !== null && searchData !== void 0 && (_searchData$range = searchData.range) !== null && _searchData$range !== void 0 && _searchData$range.from) {
          var _searchData$range2;
          searchData.range.from = new Date(searchData === null || searchData === void 0 || (_searchData$range2 = searchData.range) === null || _searchData$range2 === void 0 ? void 0 : _searchData$range2.from);
        }
        if (searchData !== null && searchData !== void 0 && (_searchData$range3 = searchData.range) !== null && _searchData$range3 !== void 0 && _searchData$range3.to) {
          var _searchData$range4;
          searchData.range.to = new Date(searchData === null || searchData === void 0 || (_searchData$range4 = searchData.range) === null || _searchData$range4 === void 0 ? void 0 : _searchData$range4.to);
        }
        setUi(prevUi => ({
          ...prevUi,
          _searchData: searchData
        }));
      } catch (error) {
        (0, _cookie.setCookie)("mco-ui-searchData", "", -1);
      }
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement(_UiContext.default.Provider, {
    value: [ui, setUi]
  }, props.children);
};
var _default = exports.default = Ui;